import styled from '@emotion/styled';

let heightContainer = `${document.documentElement.scrollWidth * 0.55}px`;

export const Container = styled.div`
  height: ${heightContainer};
`;

